import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-page-body",
    imports: [RouterOutlet],
    templateUrl: "./page-body.component.html",
    styleUrl: "./page-body.component.scss",
})
export class PageBodyComponent {}
